module.exports = __webpack_public_path__ + "static/media/soap.1d8ac469.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/connections-panel/connection-creator/soap.png
// module id = 118
// module chunks = 0